import { createContext, useContext } from "react";

// True while another account's tokens load (e.g. after switching test mode)
// and the previous account's app bar and top bar are kept up meanwhile.
// Kept out of WithAccountAccessToken so App can read it without loading it.
export const SwitchingAccountContext = createContext(false);

export const useIsSwitchingAccount = () => useContext(SwitchingAccountContext);
